'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var Lock = function Lock(_ref) {
  var color = _ref.color,
      title = _ref.title,
      className = _ref.className,
      width = _ref.width,
      height = _ref.height;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-lock ' + className, width: width, height: height, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement('path', { fill: color, className: 'path1', d: 'M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM3 4c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h-4v-3z' })
  );
};

Lock.propTypes = _bcPropTypes.iconShape;

exports.default = Lock;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Lock/Lock.js
// module id = 257
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15